<template>
    <div id="cardDetails">
        <div class="section1">        
            <el-form :inline="true" ref="cardDetailsForm" @submit.native.prevent :model="cardDetailsForm" :rules="cardDetailsRules">
                <el-form-item prop="iccid">
                    <el-input v-model.trim="cardDetailsForm.iccid" @keyup.enter.native="getSimDetailInfoHandler(cardDetailsForm.iccid, $event)" placeholder="请输入ICCID号或接入号" clearable></el-input>
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" @click="getSimDetailInfoHandler(cardDetailsForm.iccid, $event)">搜索</el-button>
                </el-form-item>
            </el-form>             
        </div>
        <template v-if="showDetail">
            <div class="section2">
                <h4>基本信息</h4>
                <el-row>
                    <el-col :span="6">
                        <img v-show="cardInfo.supplierTypeCode == 2" style="width:120px" src="./../../assets/img_yidong.png" alt="">
                        <img v-show="cardInfo.supplierTypeCode == 3" style="width:120px" src="./../../assets/img_liantong.png" alt="">
                        <img v-show="cardInfo.supplierTypeCode == 1" style="width:120px" src="./../../assets/img_dianxin.png" alt="">
                    </el-col>
                    <el-col :span="18">
                        <el-row>
                            <el-col :span="8">ICCID号： {{ cardInfo.iccid }}</el-col>
                            <el-col :span="8">接入号： {{ cardInfo.intoNo }}</el-col>                    
                            <el-col :span="8">
                                <el-col :span="14">IMSI号： {{ cardInfo.imsi }}</el-col>
                                <el-col :span="10" v-if="cardInfo.stateName != '沉默期'">IMEI号:
                                    <el-button id="imei" type="primary" size="mini" @click="queryImei(cardInfo.iccid)">显示</el-button>
                                    <span id="showtext">{{this.imei}}</span>
                                </el-col> 
                                <el-col :span="10" v-if="cardInfo.stateName != '沉默期'">开关机查询:
                                    <el-button id="imei" type="primary" size="mini" @click="switchSearch(cardInfo.iccid)">显示</el-button>
                                    <span id="showtext">{{this.switchSearchName}}</span>
                                </el-col> 
                            </el-col>
                        </el-row>
                        <el-row>
                            <el-col :span="8">激活时间： {{ cardInfo.activationrTime }}</el-col>
                            <el-col :span="8">到期时间： {{ cardInfo.expireTime }}</el-col>
                            <el-col v-if="cardInfo.simType == 1" :span="8">已用流量： {{ cardInfo.useFlow }} M</el-col>                        
                        </el-row>
                        <el-row>
                            <el-col :span="8">卡状态： {{ cardInfo.stateName=="可测试" ? "测试期": cardInfo.stateName}}</el-col>
                            <el-col :span="8">卡类型： {{ cardInfo.cardCategory }}</el-col>
                            <!-- <el-col :span="8">开关机状态：
                                <span style="color: green; font-size:16px;" v-if="cardInfo.stateName == '正常' && cardInfo.switchStatus==1">开机</span>
                                <span style="color: #cc0000; font-size:16px;" v-else-if="cardInfo.stateName == '正常' && cardInfo.switchStatus==0">关机</span>
                            </el-col>  -->
                        </el-row>

                        <el-row>
                            <el-col :span="8">数据通讯服务状态： 
                                <span v-if="cardInfo.dataState==0" style="color: red; font-size: 16px;">关闭</span>
                                <span v-else-if="cardInfo.dataState==1" style="color: green; font-size: 16px;">开启</span>
                            </el-col>
                            <el-col :span="8">语音通讯服务状态： 
                                <span v-if="cardInfo.isVoice==3" style="color: red; font-size: 16px;">关闭</span>
                                <span v-else-if="cardInfo.isVoice==2" style="color: green; font-size: 16px;">开启</span>
                            </el-col>
                            <el-col :span="8">套餐类型： {{ cardInfo.simTypeName }}</el-col>   
                            <el-col v-if="cardInfo.simType == 1" :span="8">流量池子： {{ cardInfo.simPoolName }}</el-col>
                        </el-row>

                        <el-row>
                            <el-col :span="16">阈值： 
                                <el-input  v-model.number="cardInfo.ct_state" type="number" style="width: 50%; vertical-align: middle;">
                                    <template slot="append">M</template>
                                </el-input>
                                <el-button style="margin-left: 5px; height: 32px;" @click="updateLimitNumber(cardInfo.iccid)">修改阈值(仅限流量共享)</el-button>
                            </el-col> 
                            <el-col :span="8">      
                                <el-col :span="12">
                                    <el-button type="primary" size="mini" @click="updateSimStateHandler(cardInfo.iccid)">更新最新数据</el-button> 
                                </el-col>                         
                            </el-col>
                        </el-row>
                        <el-col :span="8">语音群组ID： {{ cardInfo.voiceGroupId }}</el-col>
                    </el-col>
                </el-row>
            </div>
            <div class="section4">
                <h4>操作管理</h4>
                <div>
                    <!-- <el-button size="normal" @click="showAddPkg">添加套餐</el-button>
                    <el-button size="normal" @click="stopSimHandler">停机</el-button> 
                    <el-button size="normal" @click="resetSimHandler">复机</el-button>
                    <el-button size="normal" @click="getStopAndResetRecordData">停复机记录</el-button> -->
                    <el-button size="normal" @click="updateLimitState">{{ cardInfo.dataState==1?'关闭数据通讯服务':cardInfo.dataState==0?'开启数据通讯服务':'' }}</el-button>
                    <el-button size="normal" @click="getCloseRecordData">数据关停记录</el-button>
                     <el-button size="normal" @click="getCloseRecordDatas">短信发送记录</el-button>
                      <el-button size="normal" @click="getCloseRecordData1">刷新SIM卡网络</el-button>
                      <el-button size="normal" @click="selectPause">查询停机原因</el-button>
                       <el-button size="normal" @click="selectPause1">设备开关机状态</el-button>
                    <el-button size="normal" @click="getCardFlow">近六月流量使用情况</el-button>
                    <el-button size="normal" @click="stopSimHandler1">语音关闭服务</el-button> 
                    <el-button size="normal" @click="stopSimHandler2">语音开启服务</el-button>
                   <el-button size="normal"  @click="selectCmccQu">移动跨区域查询</el-button>
                </div>
            </div>            
            <div class="section3">
                <h4> {{ cardInfo.simType == 0 ? '套餐信息' : '流量共享池信息'}}</h4>
                <el-table :data="tableData" border v-if="cardInfo.simType == 0">
                    <el-table-column prop="prodname" label="套餐名称"></el-table-column> 
                    <el-table-column prop="totalFlow" label="单卡总流量(MB)"></el-table-column> 
                    <el-table-column prop="useFlow" label="单卡使用流量(MB)"></el-table-column> 
                    <el-table-column prop="remainsFlow" label="单卡剩余流量(MB)"></el-table-column> 
                </el-table>
                <el-table :data="tableData" border v-else>
                    <el-table-column prop="prodname" label="流量池名称"></el-table-column> 
                    <el-table-column prop="totalFlow" label="流量池总流量(MB)"></el-table-column> 
                    <el-table-column prop="useFlow" label="流量池使用流量(MB)"></el-table-column> 
                    <el-table-column prop="remainsFlow" label="流量池剩余流量(MB)"></el-table-column> 
                </el-table>
                <h4>套餐语音信息</h4>
                
                <el-table :data="voiceData">
                    <el-table-column prop="offeringName" label="套餐名称"></el-table-column> 
                    <el-table-column prop="totalAmount" label="语音总时长(分钟)"></el-table-column> 
                    <el-table-column prop="useAmount" label="已使用时长(分钟)"></el-table-column> 
                    <el-table-column prop="remainAmount" label="剩余时长(分钟)"></el-table-column> 
                </el-table>
                 <h4>系统套餐信息</h4>
                
                <el-table :data="myPkgs">
                    <el-table-column prop="packageName" label="套餐名称"></el-table-column> 
                    <el-table-column prop="stateName" label="套餐类别"></el-table-column> 
                    <el-table-column prop="flowRate" label="套餐规格"></el-table-column> 
                    <el-table-column prop="usedFlowRate" label="使用情况"></el-table-column> 
                    <el-table-column prop="remainsFlow" label="剩余情况"></el-table-column> 
                </el-table>
            </div>
            
            <div class="section5">
                <h4>备注</h4>
                <el-input v-model="cardInfo.remark" type="textarea"></el-input>
                <el-button type="primary" @click="addRemarkHandle">确定</el-button>
            </div>
        </template>



        <el-dialog title="数据关停记录" :visible.sync="dataCloseRecordVisible" width="70%" height="621px">
            <el-table :data="closeRecordData.tableData" border height="621px">
                <el-table-column prop="iccid" label="ICCID号" width="200px"></el-table-column>
                <el-table-column prop="msisdn" label="接入号" width="200px"></el-table-column>
                <el-table-column label="数据通讯服务"  width="120px">
                    <template v-slot="scope" >
                        {{scope.row.operType==1? '关闭': '开启'}}
                    </template> 
                </el-table-column>
                <el-table-column prop="remarkType" label="备注" show-overflow-tooltip></el-table-column>
                <el-table-column prop="createTime" label="创建时间" width="150px"></el-table-column>
            </el-table>
            <el-pagination
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :current-page="closeRecordData.currentPage"
                :page-sizes="[15, 50, 100, 500]"
                :page-size="closeRecordData.pageSize"
                layout="total, sizes, prev, pager, next, jumper"
                :total="closeRecordData.total">
            </el-pagination> 
        </el-dialog>
        
          <el-dialog title="短信发送记录" :visible.sync="dataCloseRecordVisibles" width="70%" height="621px">
            <el-table :data="closeRecordDatas.tableData" border height="621px">
                <el-table-column prop="sendIntoNo" label="发送人" width="200px"></el-table-column>
                <el-table-column prop="receiveIntoNo" label="接收人" width="200px"></el-table-column>
                 <el-table-column label="短信状态" width="100">
            <template slot-scope="scope">
                <span v-if="scope.row.sendState == 1" style="color: green;">发送成功</span>
                <span v-else-if="scope.row.sendState == 2" style="color: PowderBlue;">接收成功</span>
                <span v-else-if="scope.row.sendState == 3" style="color: red;">发送失败</span>
                <span v-else-if="scope.row.sendState == 4" style="color: red;">接收失败</span>
            </template>
        </el-table-column>
                <el-table-column prop="msg" label="内容" show-overflow-tooltip></el-table-column>
                <el-table-column prop="remark" label="备注" show-overflow-tooltip></el-table-column>
                <el-table-column prop="createTime" label="创建时间" width="150px"></el-table-column>
            </el-table>
            <el-pagination
                @size-change="handleSizeChanges"
                @current-change="handleCurrentChanges"
                :current-page="closeRecordDatas.currentPage"
                :page-sizes="[15, 50, 100, 500]"
                :page-size="closeRecordDatas.pageSize"
                layout="total, sizes, prev, pager, next, jumper"
                :total="closeRecordDatas.total">
            </el-pagination> 
        </el-dialog>

        <el-dialog title="停复机记录" :visible.sync="stopandresetRecordDateVisible" width="70%" height="621px">
            <el-table :data="stopandresetRecordData.tableData" border height="621px">
                <el-table-column prop="iccid" label="ICCID号" width="200px"></el-table-column>
                <el-table-column prop="msisdn" label="接入号" width="200px"></el-table-column>
                <el-table-column label="停/复机"  width="120px">
                    <template v-slot="scope" >
                        {{scope.row.type==1? '复机': '停机'}}
                    </template> 
                </el-table-column>
                <el-table-column prop="userName" label="操作人" width="200px"></el-table-column>
                <el-table-column prop="remark" label="备注" show-overflow-tooltip></el-table-column>
                <el-table-column prop="createTime" label="操作时间" width="150px"></el-table-column>
            </el-table>
            <el-pagination
                @size-change="handleSizeChange2"
                @current-change="handleCurrentChange2"
                :current-page="stopandresetRecordData.currentPage"
                :page-sizes="[15, 50, 100, 500]"
                :page-size="stopandresetRecordData.pageSize"
                layout="total, sizes, prev, pager, next, jumper"
                :total="stopandresetRecordData.total">
            </el-pagination> 
        </el-dialog>

        <el-dialog title="近六月流量使用情况" :visible.sync="cardFlowVisible">
            <el-table :data="cardFlowList">
                <el-table-column property="date" label="时间" ></el-table-column>
                <el-table-column property="flow" label="使用流量(MB)" ></el-table-column>
            </el-table>
        </el-dialog>

         <el-dialog :append-to-body="true"  title="新增套餐" :visible.sync="addPkgVisible" width="600px" @close="addPkgCancel" :close-on-click-modal="false">
            <el-form ref="addPkgForm" :model="addPkgForm" :rules="addPkgRules" label-width="100px">
                <el-form-item label="套餐名称：" prop="packageId">
                    <el-radio-group v-model="addPkgForm.packageId" class="pkgName" 
                    @change="changeAddPkgFormItem">
                        <el-radio v-for="item in pkgList" :key="item.id" :label="item.id" style="padding: 10px 0;"> 
                            {{ item.name }}
                        </el-radio>
                    </el-radio-group>
                </el-form-item>           
                <el-form-item label="备注：" prop="remark">
                    <el-input type="textarea" v-model="addPkgForm.remark" placeholder="请输入内容"></el-input>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="addPkgCancel">取 消</el-button>
                <el-button type="primary" @click="sureAddPkgHandle">确 定</el-button>
            </div> 
        </el-dialog> 
    </div>
</template>

<script>
import {getSimDetailInfo, updateSimState, stopSim, resetSim, addRemark, getImei,stopSim1,stopSim2,getPkgList,addPkg} from '@/api/sim.js'
import common from '@/utils/common.js'
export default {
    data(){
        return {
            cardDetailsForm: {
                iccid: ''
            },
            switchSearchName:'',
            showDetail: false,
            cardInfo: {
                id: '',
                iccid: '',
                intoNo: '',
                supplierTypeCode:'',
                imsi: '',
                simType: '',
                useFlow: '',
                simTypeName: '',
                simPoolName: '',
                createTime:'',
                expireTime: '',
                stateName: '',
                cardCategory: '',
                state:'',
                remark:'',
                dataState:0,
                ct_state: 0,
                switchStatus: 0,
                isVoice:'',
                activationrTime: null,
                voiceGroupId:''
            },
            tableData: [],
            voiceData: [],
            myPkgs: [],
            currentPage: 1,
            pageSize: 15,
            total: 0,
            remark: '',
            cardDetailsRules: {
                iccid: [{required: true, message: '请输入ICCID号或接入号', trigger: 'blur'}]
            },

            updateLimitStatePram:{
                supplierId:'',
                iccid:'',
                intoNo:'',
                state:'',
                id:''
            },


            //停复机记录
            stopandresetRecordDateVisible: false,
            stopandresetRecordData: {
                tableData: [],
                currentPage: 1,
                pageSize: 15,
                total: 0 
            },

            //数据关停记录
            dataCloseRecordVisible: false,
            closeRecordData: {
                tableData: [],
                currentPage: 1,
                pageSize: 15,
                total: 0                
            },
            dataCloseRecordVisibles:false,
            closeRecordDatas: {
                tableData: [],
                currentPage: 1,
                pageSize: 15,
                total: 0                
            },
            //近六月流量使用情况
            cardFlowVisible: false,
            cardFlowList: [],
            imei:'',
            pkgList: [],
            addPkgVisible:false,
            addPkgForm: {
                isNextMonth: '0',
                packageId: '',
                remark: ''
            },
        }
    },
    methods: {
         selectCmccQu(){
            common.sysRequest("sim/limitQuyu",{iccid:this.cardInfo.iccid}, 'post').then(res => {
                if (res.data.code == 200) {
                    this.$message.success('已跨出区域限制');
                } else {
                    this.$message.error(res.data.message)
                }
            }).catch(err => console.error(err));
        },

         sureAddPkgHandle(){
            this.$refs.addPkgForm.validate(valid => {
                if(valid){
                    var data = {
                        iccid:this.cardInfo.iccid,
                        packageId:this.addPkgForm.packageId,
                        remark:this.addPkgForm.remark,
                        isNextMonth:this.addPkgForm.isNextMonth
                    }
                    addPkg(data).then(res => {
                        if(res.data.code == 200){
                            this.$message.success(res.data.message);
                            this.addPkgVisible = false;
                            this.getSimDetailInfoHandler(this.cardInfo.iccid);
                        }else{
                            this.$message.error(res.data.message);
                        }
                    })                    
                }
            })
        },
         addPkgCancel(){
            this.addPkgVisible = false;
            this.$refs.addPkgForm.resetFields();
        },
        showAddPkg(){            
            var data = {
                iccid: this.cardInfo.iccid
            }            
            getPkgList(data).then(res => {
                var result = res.data.data;
                if(res.data.code == 200){
                    if(result.length > 0){
                        this.addPkgVisible = true;
                        this.pkgList = result;
                    }else{
                        this.$message.error('该套餐组下无可添加的套餐！')
                    }
                }else{
                    this.$message.error(res.data.message);
                }
            })
        },
        getSimDetailInfoHandler(iccid, $event){
            if($event){
                Object.assign(this.$data, this.$options.data());  //重置为初始值
                this.cardDetailsForm.iccid = iccid
            }
            this.$refs.cardDetailsForm.validate( valid => {
                if(valid){                   
                    var data = {
                        iccid
                    }
                    getSimDetailInfo(data).then(res => {//卡片详情接口
                        if(res.data.code == 200){
                            this.showDetail = true;
                            var result = res.data;
                            for(let key in this.cardInfo){
                                this.cardInfo[key] = res.data.data[key];
                            }
                            this.tableData = res.data.data.pkgList;
                            this.voiceData = res.data.data.voices;
                            this.myPkgs=res.data.data.myPkgs;
                            this.$nextTick(() => {
                                this.showDetail = true;
                            })
                            for( let key in this.updateLimitStatePram){
                                this.updateLimitStatePram[key] = res.data.data[key];
                            }

                            // //开关机查询
                            // if (res.data.data.state == 1) {
                            //     return
                            // }
                            // else {
                            //     this.switchSearch(result.data.iccid);
                            // }
                        }else{
                            this.$message.error(res.data.message);
                        }
                    })
                }
            });
            
        },
        updateSimStateHandler(iccid){
            if(this.cardInfo.state == '44'){
                this.$message.error('过期卡无操作权限！');
                return;
            }
            var data = { iccid };
            updateSimState(data).then(res => {
                if(res.data.code == 200){
                    this.$message.success(res.data.message);
                    this.getSimDetailInfoHandler(this.cardInfo.iccid);
                }else{
                    this.$message.error(res.data.message);
                }
            })
        },
        queryImei(iccid) {
            var data = {
                iccid: iccid
            }
            getImei(data).then (res => {
                if (res.data.code == 200) {
                    this.imei = res.data.data;
                    var imeiBtn = document.getElementById('imei');
                    var showtext = document.getElementById('showtext');
                    imeiBtn.style.display = 'none';
                    showtext.style.display = ''
                }
                else {
                    this.$message.error(res.data.message)
                }
            })
        },
        stopSimHandler(){
            if(this.cardInfo.state == '44'){
                this.$message.error('过期卡无操作权限！');
                return;
            }
            var data = {
                iccid: this.cardInfo.iccid,
                msisdn: this.cardInfo.intoNo
            }
            stopSim(data).then(res => {
                if(res.data.code == 200){
                    this.getSimDetailInfoHandler(this.cardInfo.iccid);
                    this.$message.success(res.data.message)
                }else{
                    this.$message.error(res.data.message)
                }
            })            
        },
        stopSimHandler1(){
            var data = {
                iccid: this.cardInfo.iccid,
                msisdn: this.cardInfo.intoNo,
                state:1
            }
            stopSim1(data).then(res => {
                if(res.data.code == 200){
                    this.getSimDetailInfoHandler(this.cardInfo.iccid);
                    this.$message.success(res.data.message)
                }else{
                    this.$message.error(res.data.message)
                }
            })            
        },
        stopSimHandler2(){
            var data = {
                iccid: this.cardInfo.iccid,
                msisdn: this.cardInfo.intoNo,
                state:0
            }
            stopSim2(data).then(res => {
                if(res.data.code == 200){
                    this.getSimDetailInfoHandler(this.cardInfo.iccid);
                    this.$message.success(res.data.message)
                }else{
                    this.$message.error(res.data.message)
                }
            })            
        },
        resetSimHandler(){
            if(this.cardInfo.state == '44'){
                this.$message.error('过期卡无操作权限！');
                return;
            }
            var data = {
                iccid: this.cardInfo.iccid,
                msisdn: this.cardInfo.intoNo
            }
            resetSim(data).then(res => {
                if(res.data.code == 200){
                    this.getSimDetailInfoHandler(this.cardInfo.iccid);
                    this.$message.success(res.data.message)
                }else{
                    this.$message.error(res.data.message)
                }
            })              
        },
        addRemarkHandle(){
            var data = {
                iccid: this.cardInfo.iccid,
                remark: this.cardInfo.remark
            }
            addRemark(data).then(res => {
                if(res.data.code == 200){
                    this.$message.success(res.data.message);
                }else{
                    this.$message.error(res.data.message);
                }
            })
        },

        updateLimitState(){
            if(this.cardInfo.state == '44'){
                this.$message.error('过期卡无操作权限！');
                return;
            }
            if(this.cardInfo.dataState==1){
                this.updateLimitStatePram.state =1;
            }else if(this.cardInfo.dataState==0){
                this.updateLimitStatePram.state = 0;
            }
            common.sysRequest('sim/update/limit/state', this.updateLimitStatePram, 'post').then(res => {
                if(res.data.code == 200){
                    this.getSimDetailInfoHandler(this.cardDetailsForm.iccid);
                    this.$message.success(res.data.message);
                }else{
                    this.$message.error(res.data.message);
                }
            })
        },

        //开关机查询
        switchSearch(iccid){
            common.sysRequest('simSupplier/sim/switch', {iccid}, 'post').then(res => {
                if(res.data.code == 200){
                    console.log("cesss"+res.data.data[0].status);
                    if(res.data.data[0].status==0){
                        this.switchSearchName="关机"
                    }else{
                        this.switchSearchName="开机"
                    }
                }
            })
        },
         //开关机查询
        selectPause(iccid){
            common.sysRequest('sim/other/select/sim/pause/resn', {"iccid":this.cardInfo.iccid}, 'post').then(res => {
                if(res.data.code == 200){
                    this.$message.success(res.data.data);
                }else{
                    this.$message.error(res.data.message);
                }
            })
        },
          //设备开关机状态
        selectPause1(iccid){
            common.sysRequest('sim/other/select/sim/pause/resns', {"iccid":this.cardInfo.iccid}, 'post').then(res => {
                if(res.data.code == 200){
                    this.$message.success(res.data.data);
                }else{
                    this.$message.error(res.data.message);
                }
            })
        },

        updateLimitNumber(){
            if(this.cardInfo.state == '44'){
                this.$message.error('过期卡无操作权限！');
                return;
            }
            if(this.cardInfo.ct_state<0){
                this.$message.error("阈值不可为负数");
                return;
            }
            let data = {
                totalFlow: this.cardInfo.ct_state,
                intoNo: this.cardInfo.intoNo
            }
            common.sysRequest('sim/update/limit/data', data, 'post').then(res => {
                if(res.data.code == 200){
                    this.getSimDetailInfoHandler(this.cardDetailsForm.iccid);
                    this.$message.success(res.data.message);
                }else{
                    this.$message.error(res.data.message);
                }
            })
        },

        //停复机记录
        getStopAndResetRecordData($event){
            common.resetCurrentPage(this, $event, 'stopandresetRecordData');
            let data = common.getRequestParams(this, 'stopandresetRecordData', {iccid: this.cardInfo.iccid});
            common.sysRequest('simSupplier/sim/stop/info', data, 'post').then(res => {
                common.listCallback(this, res, 'stopandresetRecordData');
                if(!this.stopandresetRecordDateVisible) {
                    console.log(this.stopandresetRecordData.tableData)
                    this.stopandresetRecordDateVisible = true;
                }              
            })   
        },

        //数据关停记录
        getCloseRecordData($event){
            common.resetCurrentPage(this, $event, 'closeRecordData');
            let data = common.getRequestParams(this, 'closeRecordData', {iccid: this.cardInfo.iccid});
            common.sysRequest('simSupplier/sim/list', data, 'post').then(res => {
                common.listCallback(this, res, 'closeRecordData');
                if(!this.dataCloseRecordVisible) {
                    this.dataCloseRecordVisible = true;
                }              
            })   
        },
         //短信发送记录
        getCloseRecordDatas($event){
            common.resetCurrentPage(this, $event, 'closeRecordDatas');
            let data = common.getRequestParams(this, 'closeRecordDatas', {sendIntoNo: this.cardInfo.intoNo});
            common.sysRequest('cmcc/sms/list/new', data, 'post').then(res => {
                common.listCallback(this, res, 'closeRecordDatas');
                if(!this.dataCloseRecordVisibles) {
                    this.dataCloseRecordVisibles = true;
                }              
            })   
        },
        getCloseRecordData1(){
            var data={
                "iccid":this.cardInfo.iccid
            }
            common.sysRequest('sim/other/reload/sim', data, 'post').then(res => {
                   if(res.data.code == 200){
                    this.getSimDetailInfoHandler(this.cardInfo.iccid);
                    this.$message.success(res.data.message);
                }else{
                    this.$message.error(res.data.message);
                }         
            })  
        },

        handleSizeChange(val){
            this.closeRecordData.pageSize = val;
            this.getCloseRecordData();
        },
        
        handleSizeChanges(val){
            this.closeRecordDatas.pageSize = val;
            this.getCloseRecordDatas();
        },

        handleSizeChange2(val) {
            this.stopandresetRecordData.pageSize = val;
            this.getStopAndResetRecordData();
        },
        handleCurrentChange2(val){
            this.stopandresetRecordData.pageSize = val;
            this.getStopAndResetRecordData();
        },

        handleCurrentChange(val){
            this.closeRecordData.currentPage = val;
            this.getCloseRecordData();
        },
          handleCurrentChanges(val){
            this.closeRecordDatas.currentPage = val;
            this.getCloseRecordDatas();
        },

        //近六月流量使用情况
        getCardFlow(){
            this.cardFlowList = []; //每次点击重置为空数组
            let data = {iccid: this.cardDetailsForm.iccid}
            const formData = new FormData();
            formData.append('iccid', data.iccid);
            let arr = [];
            let str = '';
            common.sysRequest("sim/queryCmccDataAmount", formData, 'post').then(res => {
                if(res.data.code == 200){
                    for(let key in res.data.data){
                        arr = key.split('')
                        arr.splice(4, 0 ,'-')
                        str = arr.join('')
                        this.cardFlowList.unshift({'date': str,'flow': res.data.data[key]})
                    }
                    this.cardFlowVisible = true
                    
                }
            })
        }
    },
    mounted () {
        var fromPage = this.$store.state.menu.fromPage;
        var fromPageIccid = this.$store.state.menu.fromPageIccid;
        var arr = ['cardMgt', 'cardList', 'endTimeList', 'endTimeMgt'];  
        if(arr.indexOf(fromPage) != -1){
            this.cardDetailsForm.iccid = fromPageIccid;
            this.getSimDetailInfoHandler(this.cardDetailsForm.iccid);
            this.$store.commit('menu/setFromPage', '');
            this.$store.commit('menu/setFromPageIccid', '');
        }

        
    } 
}
</script>

<style lang="scss">
#cardDetails {
    font-size: 12px;

    .section1, .section2,.section3,.section4,.section5 {
        margin-bottom: 30px;  
        padding-left: 8px;
    }
    .section2 {
        .el-row {
            line-height: 40px;
        }
    }
    .section3 {
        .el-row {
            line-height: 34px;
            margin-bottom: 20px;
        }
        
        .progressOuter {
            line-height: normal;
            .el-progress {
                margin: 5px 0;
            }
        }

    }
    .section4 {
        div {
            .el-button {
                margin-right: 30px; 
            }
        }
    }
    .section5 {
        button {
            margin-top: 20px;
        }
    }
    h4 {
        font-size: 13px;
        font-weight: bold;
        padding-left: 5px;
        margin-bottom: 20px;
        margin-left: -8px;
        border-left: 3px solid #409eff;
    }



    /*新增套餐*/
    .pkgName {
        display: block;
        label.el-radio {
            width: 50%;
            margin: 10px 0 15px 0;
        }
    }
}
</style>

